import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DivisionAddEdit, DivisionFilter } from './Pages';

export const DivisionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DivisionFilter} />
        <Route exact path = {`${match.path}/AddEdit`} component={DivisionAddEdit} />
    </Fragment>
)